import { render, staticRenderFns } from "./ParcelDetailLogs.vue?vue&type=template&id=2720eb10&scoped=true&"
import script from "./ParcelDetailLogs.vue?vue&type=script&lang=js&"
export * from "./ParcelDetailLogs.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDetailLogs.vue?vue&type=style&index=0&id=2720eb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720eb10",
  null
  
)

export default component.exports